import FormNotification from '../components/FormNotification.vue';
import Notification from '../components/Notification.vue';
import SavingNotification from '../components/SavingNotification.vue';

export default {
    components: {
        FormNotification,
        Notification,
        SavingNotification,
    },

    data: function() {
        return {
            isSending: false,
            isSuccess: null,
            statusMessage: null,
            statusType: null,
        };
    },

    computed: {
        isSendingOrSuccess() {
            return this.isSending || this.isSuccess;
        },
    },

    methods: {
        validate() {
            this.statusMessage = null;

            return this.$validator.validateAll()
            .then((result) => {
                if (! result) {
                    this.parseClientErrors();
                } else {
                    this.isSending = true;
                }

                return result;
            });
        },
        parseServerErrors(error) {
            let data = error.response.data;

            let message = data.message;

            if(data.errors) {
                message = '';

                Object.keys(data.errors).forEach(key => {
                    message += `${data.errors[key][0]} <br />`;
                });
            }

            this.statusType = 'error';
            this.statusMessage = message;
        },
        parseClientErrors() {
            let errors = this.errors.collect();

            let message = '';

            Object.keys(errors).forEach(key => {
                message += `${errors[key]}. <br />`;
            });

            this.statusType = 'error';
            this.statusMessage = message;
        },
    },
};
